<template>
    <div class="animated fadeIn">
        <b-row v-if="userUnitId">
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>Xác nhận hoàn tất đối chiếu dữ liệu</strong>
                    </div>
                    <template v-if="verifyData.id">
                        <h4>Bạn đã xác nhận dữ liệu {{ verifyData.unitName }} vào ngày {{ verifyData.verifyDate | formatDate }} <i class="fa fa-check text-success"></i> </h4>
                        <br />
                    </template>
                    <label>
                        Sau khi kiểm tra và rà soát số liệu trên các báo cáo, Tôi đồng ý xác nhận dữ liệu tài sản của đơn vị <b>{{ verifyData.unitName }}</b> trên phần mềm Quản lý tài sản công, phần mềm Quản lý công trình nước sạch và phần mềm Quản lý hạ tầng giao thông đường bộ (nếu có) với hệ thống Kho cơ sở dữ liệu quốc gia về tài sản công (Kho CSDLQGTSC) hoàn toàn trùng khớp.
                    </label>
                    <hr />
                    <b-form @submit.prevent="save">
                        <b-row>
                            <b-col class="text-center">
                                <h4>Đính kèm tệp báo cáo</h4>
                                <label>(Đơn vị đính kèm tệp báo cáo bản pdf xuất ra từ 02 <b>phần mềm Quản lý tài sản công</b> và <b>Kho CSDLQGTSC</b> đến 31/12/2020)</label>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6" offset-md="3">
                                <b-form-group label="Tệp đính kèm 1:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <template v-if="verifyData.id">
                                        <label class="col-form-label"><a href="javascript:void(0)" @click="downloadFile(1, 1)">{{ verifyData.qltscFileName01 }}</a></label>
                                    </template>
                                    <template v-else>
                                        <b-form-file v-model="verifyData.qltscFile01"
                                                     accept=".pdf"
                                                     browse-text="Chọn"
                                                     placeholder="Chọn tệp tải lên..."></b-form-file>
                                    </template>
                                </b-form-group>
                            </b-col>
                            <b-col md="6" offset-md="3">
                                <b-form-group label="Tệp đính kèm 2:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <template v-if="verifyData.id">
                                        <label class="col-form-label"><a href="javascript:void(0)" @click="downloadFile(1, 2)">{{ verifyData.qltscFileName02 }}</a></label>
                                    </template>
                                    <template v-else>
                                        <b-form-file v-model="verifyData.qltscFile02"
                                                     accept=".pdf"
                                                     browse-text="Chọn"
                                                     placeholder="Chọn tệp tải lên..."></b-form-file>
                                    </template>
                                </b-form-group>
                            </b-col>
                            <b-col md="6" offset-md="3">
                                <b-form-group label="Tệp đính kèm 3:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <template v-if="verifyData.id">
                                        <label class="col-form-label"><a href="javascript:void(0)" @click="downloadFile(1, 3)">{{ verifyData.qltscFileName03 }}</a></label>
                                    </template>
                                    <template v-else>
                                        <b-form-file v-model="verifyData.qltscFile03"
                                                     accept=".pdf"
                                                     browse-text="Chọn"
                                                     placeholder="Chọn tệp tải lên..."></b-form-file>
                                    </template>
                                </b-form-group>
                            </b-col>
                            <b-col md="6" offset-md="3">
                                <b-form-group label="Tệp đính kèm 4:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <template v-if="verifyData.id">
                                        <label class="col-form-label"><a href="javascript:void(0)" @click="downloadFile(1, 4)">{{ verifyData.qltscFileName04 }}</a></label>
                                    </template>
                                    <template v-else>
                                        <b-form-file v-model="verifyData.qltscFile04"
                                                     accept=".pdf"
                                                     browse-text="Chọn"
                                                     placeholder="Chọn tệp tải lên..."></b-form-file>
                                    </template>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <hr />
                        <b-row>
                            <b-col class="text-center">
                                <h4>Đính kèm tệp báo cáo</h4>
                                <label>(Đơn vị đính kèm tệp báo cáo bản pdf xuất ra từ 02 <b>phần mềm Quản lý công trình nước sạch</b> và <b>Kho CSDLQGTSC</b> đến 31/12/2020)</label>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6" offset-md="3">
                                <b-form-group label="Tệp đính kèm 1:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <template v-if="verifyData.id">
                                        <label class="col-form-label"><a href="javascript:void(0)" @click="downloadFile(2, 1)">{{ verifyData.ctnsFileName01 }}</a></label>
                                    </template>
                                    <template v-else>
                                        <b-form-file v-model="verifyData.ctnsFile01"
                                                     accept=".pdf"
                                                     browse-text="Chọn"
                                                     placeholder="Chọn tệp tải lên..."></b-form-file>
                                    </template>
                                </b-form-group>
                            </b-col>
                            <b-col md="6" offset-md="3">
                                <b-form-group label="Tệp đính kèm 2:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <template v-if="verifyData.id">
                                        <label class="col-form-label"><a href="javascript:void(0)" @click="downloadFile(2, 2)">{{ verifyData.ctnsFileName02 }}</a></label>
                                    </template>
                                    <template v-else>
                                        <b-form-file v-model="verifyData.ctnsFile02"
                                                     accept=".pdf"
                                                     browse-text="Chọn"
                                                     placeholder="Chọn tệp tải lên..."></b-form-file>
                                    </template>
                                </b-form-group>
                            </b-col>
                            <b-col md="6" offset-md="3">
                                <b-form-group label="Tệp đính kèm 3:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <template v-if="verifyData.id">
                                        <label class="col-form-label"><a href="javascript:void(0)" @click="downloadFile(2, 3)">{{ verifyData.ctnsFileName03 }}</a></label>
                                    </template>
                                    <template v-else>
                                        <b-form-file v-model="verifyData.ctnsFile03"
                                                     accept=".pdf"
                                                     browse-text="Chọn"
                                                     placeholder="Chọn tệp tải lên..."></b-form-file>
                                    </template>
                                </b-form-group>
                            </b-col>
                            <b-col md="6" offset-md="3">
                                <b-form-group label="Tệp đính kèm 4:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <template v-if="verifyData.id">
                                        <label class="col-form-label"><a href="javascript:void(0)" @click="downloadFile(2, 4)">{{ verifyData.ctnsFileName04 }}</a></label>
                                    </template>
                                    <template v-else>
                                        <b-form-file v-model="verifyData.ctnsFile04"
                                                     accept=".pdf"
                                                     browse-text="Chọn"
                                                     placeholder="Chọn tệp tải lên..."></b-form-file>
                                    </template>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <hr />
                        <b-row>
                            <b-col class="text-center">
                                <h4>Đính kèm tệp báo cáo</h4>
                                <label>(Đơn vị đính kèm tệp báo cáo bản pdf xuất ra từ 02 <b>phần mềm Quản lý hạ tầng giao thông đường bộ</b> và <b>Kho CSDLQGTSC</b> đến 31/12/2020)</label>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6" offset-md="3">
                                <b-form-group label="Tệp đính kèm 1:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <template v-if="verifyData.id">
                                        <label class="col-form-label"><a href="javascript:void(0)" @click="downloadFile(3, 1)">{{ verifyData.htgtdbFileName01 }}</a></label>
                                    </template>
                                    <template v-else>
                                        <b-form-file v-model="verifyData.htgtdbFile01"
                                                     accept=".pdf"
                                                     browse-text="Chọn"
                                                     placeholder="Chọn tệp tải lên..."></b-form-file>
                                    </template>
                                </b-form-group>
                            </b-col>
                            <b-col md="6" offset-md="3">
                                <b-form-group label="Tệp đính kèm 2:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <template v-if="verifyData.id">
                                        <label class="col-form-label"><a href="javascript:void(0)" @click="downloadFile(3, 2)">{{ verifyData.htgtdbFileName02 }}</a></label>
                                    </template>
                                    <template v-else>
                                        <b-form-file v-model="verifyData.htgtdbFile02"
                                                     accept=".pdf"
                                                     browse-text="Chọn"
                                                     placeholder="Chọn tệp tải lên..."></b-form-file>
                                    </template>
                                </b-form-group>
                            </b-col>
                            <b-col md="6" offset-md="3">
                                <b-form-group label="Tệp đính kèm 3:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <template v-if="verifyData.id">
                                        <label class="col-form-label"><a href="javascript:void(0)" @click="downloadFile(3, 3)">{{ verifyData.htgtdbFileName03 }}</a></label>
                                    </template>
                                    <template v-else>
                                        <b-form-file v-model="verifyData.htgtdbFile03"
                                                     accept=".pdf"
                                                     browse-text="Chọn"
                                                     placeholder="Chọn tệp tải lên..."></b-form-file>
                                    </template>
                                </b-form-group>
                            </b-col>
                            <b-col md="6" offset-md="3">
                                <b-form-group label="Tệp đính kèm 4:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <template v-if="verifyData.id">
                                        <label class="col-form-label"><a href="javascript:void(0)" @click="downloadFile(3, 4)">{{ verifyData.htgtdbFileName04 }}</a></label>
                                    </template>
                                    <template v-else>
                                        <b-form-file v-model="verifyData.htgtdbFile04"
                                                     accept=".pdf"
                                                     browse-text="Chọn"
                                                     placeholder="Chọn tệp tải lên..."></b-form-file>
                                    </template>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <br />
                        <b-row v-if="!verifyData.id">
                            <b-col md="6" offset-md="3">
                                <b-form-group label=""
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-button type="submit" variant="primary">Xác nhận</b-button>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { validationMixin } from 'vuelidate'
    import { mixins } from '@/shared/mixins'
    import { required, sameAs, minLength, helpers, requiredIf } from 'vuelidate/lib/validators'

    export default {
        name: 'VerifyData',
        mixins: [validationMixin, mixins],
        data() {
            return {
                verifyData: {
                    id: null,
                },
            }
        },
        created() {
            if (this.userUnitId) {
                this.verifyData.unitId = this.userUnitId;
                this.verifyData.unitName = this.userUnitName;
                this.loadVerifyData();
            }
        },
        methods: {
            loadVerifyData() {
                var vm = this;
                this.$services.get(`data/verify-data/detail?unitId=${this.userUnitId}`).done(response => {
                    if (response) {
                        vm.verifyData = response;
                    }
                })
            },
            save() {
                var fileChoosen = false;
                if (this.verifyData.qltscFile01 || this.verifyData.qltscFile02 || this.verifyData.qltscFile03 || this.verifyData.qltscFile04
                    || this.verifyData.ctnsFile01 || this.verifyData.ctnsFile02 || this.verifyData.ctnsFile03 || this.verifyData.ctnsFile04
                    || this.verifyData.htgtdbFile01 || this.verifyData.htgtdbFile02 || this.verifyData.htgtdbFile03 || this.verifyData.htgtdbFile04) {
                    fileChoosen = true;
                }

                if (!fileChoosen) {
                    if (!confirm('Bạn chưa chọn tệp đính kèm nào cả. Bạn chắc chắn vẫn muốn xác nhận?')) {
                        return;
                    }
                }
                var vm = this;
                this.$services.upload('data/verify-data', vm.getFormData(vm.verifyData)).done((data) => {
                    this.$toastr.s('Xác nhận dữ liệu thành công');

                    vm.loadVerifyData();
                });
            },
            downloadFile(type, position) {
                this.$services.download(`data/verify-data/${this.verifyData.id}/${type}/${position}/download`);
            },
            getFormData(object) {
                const formData = new FormData();
                Object.keys(object).forEach(key => formData.append(key, object[key]));
                return formData;
            },
        }
    }
</script>
<style scoped>
</style>
